import {AutoComplete, Input, Select, Tooltip} from "antd";
import {AscRed, CloseIconSearch, DescGrey, SearchIcon,} from "../../../asset";
import style from "./SellerList.module.css";
import CustomTable from "../../../component/table/CustomTable";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {ROUTES} from "../../../constant/routeConstant";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import Breadcrumbs from "../../../component/page-components/breadcumbs/breadcumbs";
import CustomPaging from "../../../component/pagination/pagination";
import {GROLOG_URL} from "../../../constant/apiConstant";
import {onChanged} from "../../../util/Util";
import {dropdownCustom, LoadingOption, selectOption} from "../../../component/select/SelectOption";

const SellerList = () => {
  const {token, client_id, grolog_account_id, userId} = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const api = GROLOG_URL;
  const {t} = useTranslation();
  const [listData, setListData] = useState([]);
  const [searchRecommendation, setSearchRecommedation] = useState();
  const [listRecommendation, setListRecommendation] = useState([]);
  const [sorting, setSorting] = useState("asc");
  const [sortingBy, setSortingBy] = useState("distributor_id");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState();
  const [filter, setFilter] = useState();
  const [loading, setLoading] = useState(false);
  const [isFilter, setIsfilter] = useState(false);

  const [load, setLoad] = useState(false);
  const [dropdown, setDropdown] = useState([]);
  const [depot, setDepot] = useState();
  const [depotName, setDepotName] = useState();
  const [depot1, setDepot1] = useState();
  const [depotName1, setDepotName1] = useState();
  const [pageDepot, setPageDepot] = useState(1);
  const [limitDepot, setLimitDepot] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [filterDepot, setFilterDepot] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = {Authorization: tkn};
    const request = {url, method, headers, params};
    return axios(request);
  };

  const fetchData = async (data, sort, pages) => {
    setLoad(true);
    let res2 = await doGet(
      `/depot-configuration?page=1&limit=10&${param}`,
      token
    );
    let res = await doGet(
      `/seller?page=${pages ? 1 : page}&limit=${limit}&order=id ${
        sort ? sort : sorting
        }&filter=depot_id eq ${depot ? depot : res2?.data?.payload?.data[0]?.depot_id}${
        filter
          ? ", distributor_id lk " + filter
          : data
          ? ", distributor_id lk " + data
          : ""
        }&${param}`,
      token
    );
    let init = await doGet(
      `/seller/initiate?page=${
        pages ? 1 : page
        }&limit=${limit}&order=id ${sort ? sort : sorting}&filter=depot_id eq ${
        depot ? depot : res2?.data?.payload?.data[0]?.depot_id
        }${
        filter
          ? ", distributor_id lk " + filter
          : data
          ? ", distributor_id lk " + data
          : ""
        }&${param}`,
      token
    );
    let option = [];
    let list = res2?.data?.payload?.data;
    const currentDepot = [...dropdown];
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.depot_id,
          value: element.depot_name,
        };
        option.push(data);
      }
    }
    setDropdown(selectOption(currentDepot, option, "value"));
    setDepot1(res2?.data?.payload?.data[0]?.depot_id);
    setDepotName1(res2?.data?.payload?.data[0]?.depot_name);
    setListData(res?.data?.payload?.data);
    if (init?.data?.payload?.data) {
      setInitiate(init?.data?.payload?.data);
    }
    setLoad(false);
  };

  useEffect(() => {
    onChanged(dispatch, false);
    fetchData();
  }, [page, limit, filter, depot]);

  const handleDetail = (id, created) => {
    navigate(ROUTES.SELLER.DETAIL, {
      state: {
        id: id,
        created_by: created,
      },
    });
  };

  const handlePagination = (a, b) => {
    if (a && b) {
      setPage(a);
      setLimit(b);
    } else {
    }
  };

  const fetchRecommendation = async (
    page,
    limit,
    filters,
  ) => {
    if (filters.length >= 0) {
      let res = await doGet(
        `/seller/search?page=1&limit=10&filter=depot_id eq ${
          depot ? depot : depot1
          }, distributor_id||distributor_name lk ${filters}`,
        token
      );
      setListRecommendation(res?.data?.payload?.data);
    }
  };

  const onSearchRecommendation = async (value) => {
    setIsfilter(true);
    setSearchRecommedation(value);
    if (value) {
      setSearchRecommedation(value);
      await fetchRecommendation(1, 10, value);
    } else {
      setFilter("");
      setPage(1);
      setLimit(10);
      setIsfilter(false);
      setSearchRecommedation("");
      setListRecommendation([]);
      fetchData("", sorting, sortingBy, 1)
    }
  };

  const onSelectRecommendation = (data) => {
    setPage(1);
    setFilter(data.split(" - ")[0]);
    fetchData(data, sorting, sortingBy, 1);
    setIsfilter(false);
  };

  const onClearRecommendation = () => {
    setIsfilter(false);
    setFilter(null);
    setSearchRecommedation("");
    setListRecommendation([]);
    fetchData("", sorting, sortingBy, 1);
  };

  const options =
    listRecommendation &&
    listRecommendation.map((item) => ({
      value: item.value,
      label: item.value,
      id: item.id,
    }));

  const ListColumn = [
    {
      title: (
        <div style={{display: "flex", width: "auto"}}>
          <div>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("Seller ID")}
            </span>
          </div>
          <div style={{marginLeft: "10px", marginTop: "3px"}}>
            <div className={style.SortArea}>
              <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={
                    sorting === "asc" && sortingBy === "distributor_id" ? AscRed : DescGrey
                  }
                  alt="asc"
                  className={
                    sorting === "asc" && sortingBy === "distributor_id"
                      ? "w-[10px] h-[10px] cursor-pointer"
                      : "rotate-180 w-[10px] h-[10px] cursor-pointer"
                  }
                  onClick={() => {
                    doSort("asc", "distributor_id");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={
                    sorting === "desc" && sortingBy === "distributor_id" ? AscRed : DescGrey
                  }
                  alt="desc"
                  className={
                    sorting === "desc" && sortingBy === "distributor_id"
                      ? "w-[10px] h-[10px] cursor-pointer rotate-180 "
                      : "w-[10px] h-[10px] cursor-pointer"
                  }
                  onClick={() => {
                    doSort("desc", "distributor_id");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "sellerId",
      key: "sellerId",
      render: (customerId) => <span>{customerId}</span>,
    },
    {
      title: (
        <div style={{display: "flex", width: "auto"}}>
          <div>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("Seller Name")}
            </span>
          </div>
          <div style={{marginLeft: "10px", marginTop: "3px"}}>
            <div className={style.SortArea}>
              <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={
                    sorting === "asc" && sortingBy === "distributor_name"
                      ? AscRed
                      : DescGrey
                  }
                  alt="asc"
                  className={
                    sorting === "asc" && sortingBy === "distributor_name"
                      ? "w-[10px] h-[10px] cursor-pointer"
                      : "rotate-180 w-[10px] h-[10px] cursor-pointer"
                  }
                  onClick={() => {
                    doSort("asc", "distributor_name");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={
                    sorting === "desc" && sortingBy === "distributor_name"
                      ? AscRed
                      : DescGrey
                  }
                  alt="desc"
                  className={
                    sorting === "desc" && sortingBy === "distributor_name"
                      ? "w-[10px] h-[10px] cursor-pointer rotate-180 "
                      : "w-[10px] h-[10px] cursor-pointer"
                  }
                  onClick={() => {
                    doSort("desc", "distributor_name");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "sellerName",
      key: "sellerName",
      render: (name) => <span>{name}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Seller Address")}
        </span>
      ),
      dataIndex: "sellerAddress",
      key: "sellerAddress",
      render: (description) => <span>{description}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Seller Phone")}
        </span>
      ),
      dataIndex: "sellerPhone",
      key: "sellerPhone",
      render: (level) => <span>{level}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Seller Email")}
        </span>
      ),
      dataIndex: "sellerEmail",
      key: "sellerEmail",
      render: (level) => <span>{level}</span>,
    },
    // {
    //   title: (
    //     <span className="font-roboto text-lg text-[#222222] font-medium">
    //       {t("USER:ACTION_FIELD")}
    //     </span>
    //   ),
    //   dataIndex: "action",
    //   key: "action",
    //   render: (action) => action,
    // },
  ];

  const doSort = async (sort, sortBy) => {
    await setSortingBy(sortBy);
    await setSorting(sort);
    if (sort && sortBy) {
      await setSorting(sort);
      await setSortingBy(sortBy);
      fetchData("", sort, sortBy);
    }
  };
  const dataSource = listData
    ? listData.map((result) => ({
      sellerId: (
        <span className="font-roboto text-lg text-[#222222]">
            {result?.distributor_id}
          </span>
      ),

      sellerName: (
        <span className="font-roboto text-lg text-[#222222]">
            {result?.distributor_name}
          </span>
      ),
      sellerAddress: (
        <span className="font-roboto text-lg text-[#222222]">
            {result?.distributor_address}
          </span>
      ),
      sellerPhone: (
        <span className="font-roboto text-lg text-[#222222]">
            {result?.distributor_phone}
          </span>
      ),
      sellerEmail: (
        <span className="font-roboto text-lg text-[#222222]">
            {result?.distributor_email}
          </span>
      ),
      // action: (
      //   <div className="flex gap-[26px]">
      //     <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
      //       <button
      //         // onClick={() => handleDelete(result?.id, result?.updated_at)}
      //         onClick={() =>
      //           handleDetail(result?.id, result?.created_by)
      //         }
      //       >
      //         <img src={DetailIcon} alt="det"/>
      //       </button>
      //     </Tooltip>
      //   </div>
      // ),
    }))
    : null;

  const handleChangeDepot = (value, id) => {
    setDepot(value);
    setDepotName(value);
  };

  const onScrollDepot = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight || target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight + 1 &&
      !loading
    ) {
      setPageDepot(pageDepot + 1);
      target.scrollTo(0, target.scrollHeight);
      getListDepot(pageDepot, limitDepot, filterDepot)
    }
  };

  const onChangeDepot = (event) => {
    const {value} = event.target;
    const resetPage = 1;
    let filterSearch = value && `${value}`;
    setSearchValue(value);
    let filters = [filterSearch];
    filters = filters.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filters = filters.length !== 0 ? filters.join(", ") : undefined;
    const resetFilter = filters;
    setDropdown([]);
    if (value.length >= 2) {
      setDropdown([]);
      setFilterDepot(filters);
      setPageDepot(resetPage);
      setTimeout(() => {
        getListDepot(1, limitDepot, filters)
      }, 256);
    } else if (!value) {
      setLoading(true);
      setDropdown([]);
      setFilterDepot(resetFilter);
      setPageDepot(resetPage);
      getListDepot(1, limitDepot, filters)
    }
  };

  const getListDepot = async (page, limit, filter) => {
    let res2 = await doGet(
      `/depot-configuration?page=${page}&limit=${limit}${filter ? `&filter=depot_name lk ${filter}` : ""}&${param}`,
      token
    );
    let option = [];
    let list = res2?.data?.payload?.data;
    const currentDepot = [...dropdown];
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.depot_id,
          value: element.depot_name,
        };
        option.push(data);
      }
      setDropdown(selectOption(currentDepot, option, "value"));
    }
  };

  return (
    <>
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcrumbs
          jmlLevel={2}
          menuLevel1={`Master`}
          menuLevel2={`Seller`}
        />

        <h1 className="font-sans-bold text-2xl" id="title">
          {t("Seller")}
        </h1>

        <div
          className={
            style.headerContainer + " flex items-center"
          }
        >
          <AutoComplete
            options={options}
            value={searchRecommendation}
            onChange={(value) => onSearchRecommendation(value)}
            onSelect={(e) => onSelectRecommendation(e)}
          >
            <Input
              placeholder={t("Search Seller")}
              className="w-[350px] h-[47px]"
              height={47}
              width={350}
              suffix={
                <img
                  src={filter ? CloseIconSearch : SearchIcon}
                  alt="search"
                  onClick={filter ? () => onClearRecommendation() : null}
                />
              }
              value={searchRecommendation}
            />
          </AutoComplete>

          <Select
            className={style.selectContainer + " ml-3 w-[200px]"}
            value={depotName ? depotName : depotName1}
            onChange={(id, val) => handleChangeDepot(id, val)}
            onPopupScroll={(e) => onScrollDepot(e)}
            dropdownRender={(menu) =>
              dropdownCustom(
                menu,
                (value) => onChangeDepot(value),
                searchValue
              )
            }>
            {!loading
              ? dropdown
              : [...dropdown, LoadingOption()]}
          </Select>
        </div>

        <div className={style.tableContainer}>
          <CustomTable columns={ListColumn} data={dataSource}/>
          <div className={style.containerPagination + " mt-[-45px]"}>
            <CustomPaging
              idLimit="ddlrowsperpagemustselllist"
              idPagination="btnpaginationmustselllist"
              size="small"
              current={page}
              defaultCurrent={page}
              pageSize={limit}
              total={initiate && initiate?.count_data}
              pageSizeOptions={initiate && initiate?.valid_limit}
              onShowSizeChange={() => handlePagination()}
              handlePaging={(a, b) => handlePagination(a, b)}
              title={t("COMMON:ROW_PAGE")}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SellerList;
